import React from 'react';
import { FormikConfig, FormikValues } from 'formik';

interface iFormikStep
  extends Pick<FormikConfig<FormikValues>, 'children' | 'validationSchema'> {
  label: string;
  type?: string;
  notFor?: string;
}

const FormikStep: React.FC<iFormikStep> = ({ children }) => {
  return <>{children}</>;
};

// default props
FormikStep.defaultProps = {
  type: 'all',
};

export default FormikStep;
